import * as ACTIONS from '../actions/navParser';

export const setPlayAndGoNodes = (node) => ({ type: ACTIONS.SET_PLAY_AND_GO_NODES, node });

export const navParser = (country) => (dispatch, getState) => {
  const { nav, metadata } = getState();
  const layoutConfiguration = metadata.layout_node_configuration ? JSON.parse(metadata.layout_node_configuration) : false;
  const layoutRegion = layoutConfiguration[country] || layoutConfiguration.default || false;
  let playAndGoNodes = [];

  if (layoutRegion) {
    playAndGoNodes = Object.keys(layoutRegion).reduce((previous, node) => {
      if (layoutRegion[node].type == 'layout' && layoutRegion[node].layout === 'playandgo') {
        previous.push(node);
      }
      return previous;
    }, []);
  }

  nav.nodeList.map(node => {
    if (playAndGoNodes.indexOf(node.code) > -1) {
      dispatch(setPlayAndGoNodes(node));
    }
  });
};
